<template>
  <div class="main dashboard">

    <loading v-model:active="isLoading"
             :is-full-page="true"
             color="var(--primary-color)">
    </loading>

    <div class="dashboard-component" v-if="!isLoading">
      <div class="dashboard-container">

        <div class="dashboard-container-entry">
          <div class="contact-appointment-container" v-on:click="redirectToUrl('/contacts')">
            <div class="header">{{ $t('contacts') }}</div>
            <div class="count-icon-container">
              <i class="fa fa-user fa-3x"></i>
              <span>{{ outgoingContactData.accepted + incomingContactData.accepted }}</span>
            </div>
          </div>

          <div class="dashboard-details-container-outer-wrapper">
            <div class="dashboard-details-container-outer">
              <div class="dashboard-details-container">
                <div class="value-header">{{ $t('requests_sent') }}</div>
                <div class="value-container">
                  <div class="value-title value-title-total"
                       v-bind:class="outgoingContactData.total > 0 ? 'has-value': ''"
                       v-on:click="openUserDialog('all_request_sent',outgoingContactData.total)">
                    {{ $t('all-others') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value value-total"
                         :style="`width: ${calculateWidth(outgoingContactData.total,outgoingContactData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ outgoingContactData.total }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="outgoingContactData.accepted > 0 ? 'has-value': ''"
                       v-on:click="openUserDialog('accepted_request_sent',outgoingContactData.accepted)">{{
                      $t('accepted')
                    }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(outgoingContactData.accepted,outgoingContactData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ outgoingContactData.accepted }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="outgoingContactData.open > 0 ? 'has-value': ''"
                       v-on:click="openUserDialog('pending_request_sent',outgoingContactData.open)">
                    {{ $t('pending') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(outgoingContactData.open,outgoingContactData.total)}%`">&nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ outgoingContactData.open }}
                  </div>
                </div>
              </div>
            </div>
            <div class="dashboard-details-container-outer">
              <div class="dashboard-details-container">
                <div class="value-header">{{ $t('requests_received') }}</div>
                <div class="value-container">
                  <div class="value-title value-title-total"
                       v-bind:class="incomingContactData.total > 0 ? 'has-value': ''"
                       v-on:click="openUserDialog('all_request_received',incomingContactData.total)">{{
                      $t('all-others')
                    }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value value-total"
                         :style="`width: ${calculateWidth(incomingContactData.total,incomingContactData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ incomingContactData.total }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="incomingContactData.accepted > 0 ? 'has-value': ''"
                       v-on:click="openUserDialog('accepted_request_received',incomingContactData.accepted)">
                    {{ $t('accepted') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(incomingContactData.accepted,incomingContactData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ incomingContactData.accepted }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="incomingContactData.rejected > 0 ? 'has-value': ''"
                       v-on:click="openUserDialog('rejected_request_received',incomingContactData.rejected)">
                    {{ $t('rejected') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(incomingContactData.rejected,incomingContactData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ incomingContactData.rejected }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="incomingContactData.open > 0 ? 'has-value': ''"
                       v-on:click="openUserDialog('pending_request_received',incomingContactData.open)">{{ $t('open') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(incomingContactData.open,incomingContactData.total)}%`">&nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ incomingContactData.open }}
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>

        <div class="dashboard-container-entry">
          <div class="contact-appointment-container" v-on:click="redirectToUrl('/appointments')">
            <div class="header">{{ $t('appointments') }}</div>
            <div class="count-icon-container">
              <i class="fa fa-clock fa-3x"></i>
              <span>{{ incomingAppointmentData.accepted + outgoingAppointmentData.accepted }}</span>
            </div>
          </div>

          <div class="dashboard-details-container-outer-wrapper">
            <div class="dashboard-details-container-outer">
              <div class="dashboard-details-container">
                <div class="value-header">{{ $t('requests_sent') }}</div>
                <div class="value-container">
                  <div class="value-title value-title-total"
                       v-bind:class="outgoingAppointmentData.total > 0 ? 'has-value': ''"
                       v-on:click="openAppointmentDialog('all_request_sent',outgoingAppointmentData.total)">
                    {{ $t('all-others') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value value-total"
                         :style="`width: ${calculateWidth(outgoingAppointmentData.total,outgoingAppointmentData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ outgoingAppointmentData.total }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="outgoingAppointmentData.accepted > 0 ? 'has-value': ''"
                       v-on:click="openAppointmentDialog('accepted_request_sent',outgoingAppointmentData.accepted)">
                    {{ $t('accepted') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(outgoingAppointmentData.accepted,outgoingAppointmentData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ outgoingAppointmentData.accepted }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="outgoingAppointmentData.canceled + outgoingAppointmentData.rejected > 0 ? 'has-value': ''"
                       v-on:click="openAppointmentDialog('canceled_request_sent',outgoingAppointmentData.canceled + outgoingAppointmentData.rejected)">
                    {{ $t('canceled') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(outgoingAppointmentData.canceled + outgoingAppointmentData.rejected,outgoingAppointmentData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ outgoingAppointmentData.canceled + outgoingAppointmentData.rejected }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="outgoingAppointmentData.open > 0 ? 'has-value': ''"
                       v-on:click="openAppointmentDialog('pending_request_sent',outgoingAppointmentData.open)">
                    {{ $t('pending') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(outgoingAppointmentData.open,outgoingAppointmentData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ outgoingAppointmentData.open }}
                  </div>
                </div>
              </div>
            </div>
            <div class="dashboard-details-container-outer">
              <div class="dashboard-details-container">
                <div class="value-header">{{ $t('requests_received') }}</div>
                <div class="value-container">
                  <div class="value-title value-title-total"
                       v-bind:class="incomingAppointmentData.total > 0 ? 'has-value': ''"
                       v-on:click="openAppointmentDialog('all_request_received',incomingAppointmentData.total)">
                    {{ $t('all-others') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value value-total"
                         :style="`width: ${calculateWidth(incomingAppointmentData.total,incomingAppointmentData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ incomingAppointmentData.total }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="incomingAppointmentData.accepted > 0 ? 'has-value': ''"
                       v-on:click="openAppointmentDialog('accepted_request_received',incomingAppointmentData.accepted)">
                    {{ $t('accepted') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(incomingAppointmentData.accepted,incomingAppointmentData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ incomingAppointmentData.accepted }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="incomingAppointmentData.canceled + incomingAppointmentData.rejected > 0 ? 'has-value': ''"
                       v-on:click="openAppointmentDialog('canceled_request_received',incomingAppointmentData.canceled + incomingAppointmentData.rejected)">
                    {{ $t('canceled') }}
                  </div>
                  <div class="value-wrapper" v-if="outgoingAppointmentData">
                    <div class="value"
                         :style="`width: ${calculateWidth(incomingAppointmentData.canceled + incomingAppointmentData.rejected,incomingAppointmentData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ incomingAppointmentData.canceled + incomingAppointmentData.rejected }}
                  </div>
                </div>
                <div class="value-container">
                  <div class="value-title"
                       v-bind:class="incomingAppointmentData.open > 0 ? 'has-value': ''"
                       v-on:click="openAppointmentDialog('pending_request_received',incomingAppointmentData.open)">
                    {{ $t('open') }}
                  </div>
                  <div class="value-wrapper">
                    <div class="value"
                         :style="`width: ${calculateWidth(incomingAppointmentData.open,incomingAppointmentData.total)}%`">
                      &nbsp;
                    </div>
                  </div>
                  <div class="value-plain">
                    {{ incomingAppointmentData.open }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


    <custom-dialog id="appointmentDialog" ref="appointmentDialog" class="detail-dialog"
                   :submitButtonText="$t('close')">


      <span class="header" v-if="relevantDataIdentifier">{{ $t(relevantDataIdentifier) }}</span>
      <div class="appointment-list" v-if="relevantAppointments.length > 0">

        <div class="appointment" v-for="appointment of relevantAppointments" :key="appointment.id">
          <div class="appointment-content">
            <div class="appointment-content-left">
              <div class="name">{{
                  appointment.isCanceled() ? $t('canceled') + ':' : appointment.isRequest() ? $t('requested') + ':' : appointment.isConfirmed() ? $t('confirmed') + ':' : ''
                }} {{ appointment.name }}
              </div>
              <i class="fas fa-calendar-plus fa-2x download-calendar-icon" v-if="appointment.isConfirmed()"
                 v-on:click="downloadCalendarForAppointment(appointment)"> <span>iCal</span> </i>
            </div>

            <div class="appointment-content-center">
              <div class="status">
                <div class="appointment-times">
                      <span><i class="far fa-clock"/>

                  {{ formatTime(appointment.from, "L") }}      {{
                          formatTime(appointment.from, "HH:mm")
                        }} - {{ formatTime(appointment.to, "HH:mm") }} {{ timezone(appointment.from) }}</span>
                </div>
                <span>
                      <i class="far fa-map-marker-alt"/>
                      {{ $t('place') }}: {{ getRoomStringForAppointment(appointment) }}
                    </span>
              </div>
            </div>
          </div>

          <div class="description">
            <div><i class="far fa-info-circle"/>{{ appointment.description }}</div>
          </div>
        </div>
      </div>

    </custom-dialog>

    <custom-dialog id="userDialog" ref="userDialog" class="detail-dialog"
                   :submitButtonText="$t('close')">

      <span class="header" v-if="relevantDataIdentifier">{{ $t(relevantDataIdentifier) }}</span>

      <transition-group name="animatedList" tag="div"
                        class="transition-list"
                        v-bind:css="false"
                        v-on:before-enter="animationBeforeEnter"
                        v-on:enter="animationEnter"
                        v-on:leave="animationLeave">
        <networkers-card v-for="(user, index) in networkers" v-bind:networker="user" v-bind:data-index="index"
                         v-bind:go-to-profile="openProfileDialog"
                         :key="user.id"></networkers-card>
      </transition-group>
    </custom-dialog>

  </div>
</template>


<script>

import backend from "@/mm-backend";
import router from "@/router";
import {isDefined} from "@/utils";
import NetworkersCard from "@/components/cards/NetworkersCard.vue";
import {eventBus, logger} from "@/main";
import {networkersMixIn} from "@/mixins/networkers-mixin";
import {User} from "@/entities/User";
import CustomDialog from "@/components/Dialog.vue";
import {appointmentsMixin} from "@/mixins/appointments-mixin";

export default {
  components: {CustomDialog, NetworkersCard},
  mixins: [networkersMixIn, appointmentsMixin],
  data() {
    return {
      incomingContactData: {},
      outgoingContactData: {},
      incomingAppointmentData: {},
      outgoingAppointmentData: {},
      allAppointments: [],
      relevantAppointments: [],
      relevantDataIdentifier: undefined
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    openProfileDialog(user, isRecommendation) {
      eventBus.emit('open-profile-dialog', {
        user: user,
        isRecommendation: isRecommendation
      });
    },
    calculateWidth(count, max) {
      const value = (count / max) * 100
      return value > 0 ? value : 1;
    },
    loadData() {
      const loadingPromises = [];
      loadingPromises.push(backend.getChatUsers());
      loadingPromises.push(backend.getAllAppointments());
      Promise.all(loadingPromises).then((resp) => {
            const contactData = resp[0].data;
            const appointmentData = resp[1].data;
            this.incomingContactData = contactData.incoming;
            this.outgoingContactData = contactData.outgoing;
            this.allAppointments = appointmentData.appointments;
            this.incomingAppointmentData = appointmentData.incoming;
            this.outgoingAppointmentData = appointmentData.outgoing;
            this.isLoading = false;
          }, error => {
            logger.error(error);
            this.isLoading = false;
          }
      );
    },
    openUserDialog(context, value) {
      if (isDefined(value) && value <= 0) {
        return;
      }
      this.relevantDataIdentifier = context;
      switch (context) {
        case 'all_request_sent': {
          this.loadContactsAndOpenDialog({
            direction: 'out',
            confirmedOnly: false
          });
          break;
        }
        case 'accepted_request_sent': {
          this.loadContactsAndOpenDialog({
            direction: 'out',
            confirmedOnly: true
          });
          break;
        }
        case 'pending_request_sent': {
          this.loadContactsAndOpenDialog({
            direction: 'out',
            confirmedOnly: false
          }, (user) => {
            return !user.match_confirmed;
          });
          break;
        }
        case 'all_request_received': {
          this.loadContactsAndOpenDialog({
            direction: 'in',
            confirmedOnly: false
          });
          break;
        }
        case 'accepted_request_received': {
          this.loadContactsAndOpenDialog({
            direction: 'in',
            confirmedOnly: true
          });
          break;
        }
        case 'rejected_request_received': {
          this.loadContactsAndOpenDialog({
            direction: 'in',
            confirmedOnly: false
          }, (user) => {
            return user.match_ignored;
          });
          break;
        }
        case 'pending_request_received': {
          this.loadContactsAndOpenDialog({
            direction: 'in',
            confirmedOnly: false
          }, (user) => {
            return !user.match_confirmed && !user.match_ignored;
          });
          break;
        }
        default: {
        }
      }
    },
    openAppointmentDialog(context, value) {
      if (isDefined(value) && value <= 0) {
        return;
      }
      this.relevantDataIdentifier = context;
      if (isDefined(this.allAppointments)) {
        switch (context) {
          case 'all_request_sent': {
            this.relevantAppointments = this.allAppointments.filter(a => a.isOutGoingRequest(User.me()));
            break;
          }
          case 'accepted_request_sent': {
            this.relevantAppointments = this.allAppointments.filter(a => a.isOutGoingRequest(User.me()) && a.isConfirmed())
            break;
          }
          case 'canceled_request_sent': {
            this.relevantAppointments = this.allAppointments.filter(a => a.isOutGoingRequest(User.me()) && a.isCanceled())
            break;
          }
          case 'pending_request_sent': {
            this.relevantAppointments = this.allAppointments.filter(a => a.isOutGoingRequest(User.me()) && a.isRequest())
            break;
          }
          case 'all_request_received': {
            this.relevantAppointments = this.allAppointments.filter(a => !a.isOutGoingRequest(User.me()))
            break;
          }
          case 'accepted_request_received': {
            this.relevantAppointments = this.allAppointments.filter(a => !a.isOutGoingRequest(User.me()) && a.isConfirmed())
            break;
          }
          case 'canceled_request_received': {
            this.relevantAppointments = this.allAppointments.filter(a => !a.isOutGoingRequest(User.me()) && a.isCanceled())
            break;
          }
          case 'pending_request_received': {
            this.relevantAppointments = this.allAppointments.filter(a => !a.isOutGoingRequest(User.me()) && a.isRequest())
            break;
          }
          default: {
          }
        }
        if (isDefined(this.$refs.appointmentDialog)) {
          this.$refs.appointmentDialog.openDialog();
        }
      }
    },
    beforeGet() {
      this.getObservable = backend.matches.bind(backend);
    },
    afterGet() {
      if (isDefined(this.$refs.userDialog)) {
        this.$refs.userDialog.openDialog();
      }
    },
    loadContactsAndOpenDialog(payload, filterFunction) {
      this.params = {
        ...payload,
        sort: this.sortValue
      }
      this.get(filterFunction);
    },
    get(filterFunction) {
      this.beforeGet();
      this.isLoading = true;
      let self = this;
      this.getObservable(this.params).then(function (resp) {
        if (isDefined(filterFunction) && isDefined(resp.data) && isDefined(resp.data.users)) {
          resp.data.users = resp.data.users.filter(u => filterFunction(u) === true);
        }
        self.setDataFromMatchingResponse(resp);
        self.isLoading = false;
        self.afterGet();
      }, error => {
        logger.error(error);
        self.isLoading = false;
      });
    },
    redirectToUrl(url) {
      router.push(url);
    }
  }
}

</script>


<style lang="less">
.dashboard {
  height: 50vh;
  padding-right: 10px !important;
}

.main {


  .detail-dialog {
    .dialog-content {
      padding: 25px !important;
      max-height: calc(100vh - 140px) !important;

      .header {
        margin-bottom: 10px !important;
      }

      .transition-list, .appointment-list {
        overflow: auto;
        overflow-x: hidden;
      }
    }
  }

  .dashboard-component {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .user-list, .appointment-list {
      margin-top: 24px;
    }

    .dashboard-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      height: 100%;

      &-entry {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        margin: 6px 0;
        min-height: 20%;

        .contact-appointment-container {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          background: var(--primary-color);
          margin-right: 12px;
          padding: 12px;
          box-shadow: 2px 2px 6px #888;
          color: #FFFFFF;
          cursor: pointer;
          min-width: 20%;
          overflow: hidden;
          height: 100%;
          position: relative;

          .header {
            text-align: left;
            font-size: 1.5em;
            overflow: hidden;
            line-height: 1em;
          }

          .count-icon-container {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
            margin-left: 30px;


            > i, > span {
              margin-right: auto;
            }

            > span {
              font-size: 5em;
            }
          }
        }


        .dashboard-details-container-outer-wrapper {
          display: flex;
          flex-direction: row;
          width: 80%;
          height: 100%;
          font-size: 20px;

          .value-header {
            font-weight: bold;
            text-align: left;
          }


          .dashboard-details-container-outer {
            display: flex;
            flex-direction: column;
            box-shadow: 2px 2px 6px #888;
            width: 50%;
            margin-right: 12px;
            overflow: hidden;


            .dashboard-details-container {
              display: flex;
              flex-direction: column;
              padding: 6px 12px;
              background: #FFFFFF;
              width: 100%;
              height: 100%;


              .value-container {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                width: 100%;
                height: 30px;


                .value-title {
                  min-width: 20%;
                  width: 30%;
                  text-align: left;
                  text-transform: lowercase;
                  overflow: hidden;
                  white-space: nowrap;
                }

                .value-title.has-value {
                  cursor: pointer;
                }

                .value-title-total {
                  font-weight: bold;
                }

                .value-wrapper {
                  width: 60%;
                  min-width: 60%;
                  height: 100%;
                  display: flex;
                  align-items: center;

                  .value {
                    width: 0;
                    line-height: 1em;
                    background: #858585;
                  }

                  .value-total {
                    background: #141946;
                  }
                }

                .value-plain {
                  width: 10%;
                  min-width: 10%;
                  text-align: right;
                }
              }

              .value-container:last-of-type {
                margin: 0;
              }
            }
          }

          .dashboard-details-container-outer:last-of-type {
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
